import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { 
SERVICE_FULL_DESCRIPTION_1,
SERVICE_FULL_DESCRIPTION_2,
SERVICE_FULL_DESCRIPTION_3
} from '../config/notebook-config';

@Component({
  standalone: true,
    selector: 'app-home',
    imports: [
        CommonModule,
        MatButtonModule
    ],
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent {
  titleText: string="Welcome to Quantum Service!";
  descriptionText1 = SERVICE_FULL_DESCRIPTION_1;
  descriptionText2 = SERVICE_FULL_DESCRIPTION_2;
  descriptionText3 = SERVICE_FULL_DESCRIPTION_3;
  buttonText:string="Go to Quantum Emulators";
  constructor(private router: Router) {}

  goToNotebookList() {
    this.router.navigateByUrl('/list');
  }
}
